<script>
  import { createEventDispatcher } from 'svelte';

  import Notification from '@utils/notification';
  import Modal from '@components/Modal.svelte';
  import Button from '@components/Button.svelte';
  import Checkbox from '@components/Checkbox.svelte';
  import Text from '@components/Text.svelte';
  import GroupAjax from '@ajax/group';

  const dispatch = createEventDispatcher();

  export let mobile = false;
  export let showModal;
  export let group;

  let duplicating = false;
  let addMembers = false;
  let preservePrivacy = false;

  let close = function () {
    showModal = false;
    duplicating = false;
    preservePrivacy = false;
    addMembers = true;
    dispatch('close');
  };

  let duplicate = async function () {
    if (duplicating) {
      return;
    }

    duplicating = true;

    try {
      let data = await GroupAjax.duplicate(group, {
        addMembers,
        preservePrivacy,
      });

      Notification.send({
        text: `List has been duplicated - <a href='${data.url}' style='color: white; border-bottom: 1px solid #ececec; padding-bottom: 2px;'>${data.name}</a>`,
      });

      dispatch('success', {
        group: data,
      });
    } catch (err) {
      if (err) {
        Notification.send({
          text: `Unable to duplicate list. We will look into this issue`,
          type: 'error',
        });
      }
    }

    close();
  };
</script>

<style style="text/scss" lang="scss">
  .ui-header {
    font-weight: 500;
    font-size: 16px;
  }
  .ui-group-name {
    margin-top: 60px;
    font-size: 25px;
    line-height: 26px;
    font-weight: 500;
  }
  .ui-actions {
    margin-top: 65px;
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;
    .cancel-btn {
      color: #000;
      font-size: 15px;
      margin-top: 12px;
      font-weight: 500;
      border: none;
      background: transparent;
    }
  }

  * :global(.duplicate-modal) {
    width: 490px !important;
    border-radius: 16px !important;
    padding: 40px !important;
  }
</style>

<div>
  <Modal
    containerClass="duplicate-modal"
    on:close={close}
    show={showModal}
    showCloseButton={false}
    fadeInDuration={200}
    mobile={mobile}>
    <div slot="content" style="text-align: center">
      <div class="ui-header">Duplicate List</div>
      <div class="ui-group-name">
        <Text text={group.name} />
      </div>

      <div
        style="margin-top: 50px; width: 220px; margin-left: auto; margin-right:
      auto; margin-bottom: -20px;">
        <div style="display: flex; margin-top: 10px; margin-bottom: 10px;">
          <div style="flex-shrink: 0">
            <Checkbox
              checked={preservePrivacy}
              on:change={() => {
                preservePrivacy = !preservePrivacy;
              }} />
          </div>

          <div style="display: flex; flex-direction: column; margin-left: 13px;">
            <div
              style="cursor: pointer; text-align: left"
              on:click={() => {
                preservePrivacy = !preservePrivacy;
              }}>
              Preserve Privacy Settings
            </div>
          </div>
        </div>

        <div style="display: flex; margin-top: 20px; margin-bottom: 10px;">
          <div style="flex-shrink: 0">
            <Checkbox
              checked={addMembers}
              on:change={() => {
                addMembers = !addMembers;
              }} />
          </div>

          <div style="display: flex; flex-direction: column; margin-left: 13px;">
            <div
              style="cursor: pointer; text-align: left"
              on:click={() => {
                addMembers = !addMembers;
              }}>
              Preserve list contributors and followers
            </div>
          </div>
        </div>
      </div>

      <div class="ui-actions">
        <Button
          text={duplicating ? '<i class="fa fa-spin fa-spinner"></i>&nbsp;&nbsp;Duplicating' : 'Duplicate'}
          style="width: 275px; height: 48px"
          on:click={duplicate} />
        <button class="cancel-btn" on:click={close}>Cancel</button>
      </div>
    </div>
  </Modal>
</div>
